import Tooltip from '@mui/material/Tooltip';

import useAppDispatch from '@webclient/hooks/useAppDispatch';

import { stopDictation } from '@webclient/state/slices/search-widget-dictation';

import SlashCircleIcon from '~icons/knowz-iconify/slash-circle';

import { IconButton } from '@knowz/knowz-ui';
import { useTranslate } from '@tolgee/react';

export default function Dictation() {
  const dispatch = useAppDispatch();
  const { t } = useTranslate();

  function handleStopDictation() {
    dispatch(stopDictation());
  }

  return (
    <Tooltip
      title={t('layout.searchWidget.dictation.off', 'Turn off live dictation')}
      arrow
      placement="top"
    >
      <IconButton
        onClick={handleStopDictation}
        variant="ghost"
        color="secondary"
        size="small"
      >
        <SlashCircleIcon />
      </IconButton>
    </Tooltip>
  );
}
